module.exports = __webpack_public_path__ + "img/fail.26cbc3ff.png";